import React from 'react';

const Preparing = () => {
    return (
        <div>
            <div className='text-lg mt-14 mb-[440px] text-center'>작업중입니다...</div>
        </div>
    );
};

export default Preparing;